import * as Blockly from 'blockly/core';

function range(start, end) {
    return (new Array(end - start + 1)).fill(undefined).map((_, i) => i + start);
}

Blockly.Python['text_join'] = function(block) {
  let code = [...range(0,block.itemCount_-1)].map((e,i)=>Blockly.Python.valueToCode(block, `ADD${i}`,Blockly.Python.ORDER_NONE) || '\'\'').map(e=>e.match(/('.*'|".*"|`.*`)/gm) ? e : `str(${e})`).join(' + ');
  return [code, Blockly.Python.ORDER_FUNCTION_CALL];
};